export enum PromotionUserTypeConditionEnum {
  NEW_USER = 'NEW_USER',
  ALL_USER = 'ALL_USER',
  SPECIFY_USER = 'SPECIFY_USER',
}
